import { createRef } from 'react';

import type { MutableRefObject } from 'react';

export enum RefKeys {
  APP = 'app',
}

type RefsMap = {
  [key in RefKeys]?: MutableRefObject<HTMLElement | null>;
};

class RefManager {
  private refs: RefsMap = {};

  createRef<T extends HTMLElement>(key: RefKeys): MutableRefObject<T | null> {
    if (!this.refs[key]) {
      this.refs[key] = createRef<T>() as MutableRefObject<T | null>;
    }
    return this.refs[key] as MutableRefObject<T | null>;
  }

  setElement(key: RefKeys, element: HTMLElement): MutableRefObject<HTMLElement | null> {
    if (!this.refs[key]) {
      this.refs[key] = { current: element };
    } else {
      this.refs[key]!.current = element;
    }
    return this.refs[key]!;
  }

  getRef<T extends HTMLElement>(key: RefKeys): MutableRefObject<T | null> {
    return (this.refs[key] as MutableRefObject<T>) || { current: null };
  }

  getElement<T extends HTMLElement>(key: RefKeys): T | null {
    return this.refs[key]?.current as T | null;
  }

  deleteRef(key: RefKeys): void {
    delete this.refs[key];
  }
}

export const refManager = new RefManager();
